export const handleHttpStatusCode = (xhr) => {
  if (xhr.status >= 200 && xhr.status < 400) {
    return Promise.resolve(xhr.data);
  } else {
    return Promise.reject(xhr)
  }
}
